import { createContext, useEffect, useState } from "react";

export const AdditionalSignaturesContext = createContext(null);
export const ADDITIONAL_SIGNATURES_CONTEXT_KEY = "additionalSignaturesContextData";

export const AdditionalSignaturesContextProvider = ({ children }) => {
    const [documentData, setDocumentData] = useState(null);
    const [signatureData, setSignatureData] = useState(null);
    const [completedBoxes, setCompletedBoxes] = useState([]);

    const signerDTO = documentData?.SignerDTO;
    const signatureBoxes = signerDTO?.SignatureBoxes;

    const isSignatureBoxesFlow = !!signatureBoxes;

    const isSignatureRecorded = !!signatureData;

    const saveAdditionalSignaturesDataToLocalStorage = (dataToSaveOverride = {}) => {
        const dataToSave = {
            documentData: dataToSaveOverride.documentData ?? documentData,
            signatureData: dataToSaveOverride.signatureData ?? signatureData,
            completedBoxes: dataToSaveOverride.completedBoxes ?? completedBoxes,
        };

        localStorage.setItem(ADDITIONAL_SIGNATURES_CONTEXT_KEY, JSON.stringify(dataToSave));
    };

    const loadAdditionalSignaturesDataFromLocalStorage = () => {
        const savedData = localStorage.getItem(ADDITIONAL_SIGNATURES_CONTEXT_KEY);
        if (!savedData) return;

        try {
            const parsedData = JSON.parse(savedData);

            setDocumentData(parsedData?.documentData ?? null);
            setSignatureData(parsedData?.signatureData ?? null);
            setCompletedBoxes(parsedData?.completedBoxes ?? []);
        } catch (error) {
            console.error("Error loading additional signatures data from localStorage", error);
        }
    };

    useEffect(() => {
        loadAdditionalSignaturesDataFromLocalStorage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const addCompletedBox = (boxData) => {
        const newCompletedBoxesData = [
            ...completedBoxes,
            boxData,
        ];

        setCompletedBoxes(newCompletedBoxesData);
    }

    const checkIfBoxIsCompleted = (boxData) => {
        return completedBoxes.find((box) => {
            return (box.PosX === boxData.PosX && 
                    box.Page === boxData.Page && 
                    box.PosY === boxData.PosY && 
                    box.SizeX === boxData.SizeX && 
                    box.SizeY === boxData.SizeY)
        });
    }

    const orderBoxesByPage = () => {
        signatureBoxes?.sort((previous, next) => {
            if (previous.Page === next.Page) {
                return previous.PosY - next.PosY;
            }
            return previous.Page - next.Page
        });
    }

    const getNextIncompletedBox = () => {
        let nextIncompleted = null;

        if (!isSignatureBoxesFlow) return null;

        for (const box of signatureBoxes) {
            if (!checkIfBoxIsCompleted(box)) {
                nextIncompleted = box;
                break;
            }
        }

        return nextIncompleted;
    }
    
    orderBoxesByPage();

    return (
        <AdditionalSignaturesContext.Provider value={{
            signatureBoxes,
            setDocumentData,
            signatureData,
            setSignatureData,
            isSignatureBoxesFlow,
            isSignatureRecorded,
            completedBoxes,
            addCompletedBox,
            checkIfBoxIsCompleted,
            signerDTO,
            getNextIncompletedBox,
            documentData,
            saveAdditionalSignaturesDataToLocalStorage,
            loadAdditionalSignaturesDataFromLocalStorage,
        }}>
            {children}
        </AdditionalSignaturesContext.Provider>
    )
}
